import { j as r } from "./jsx-runtime-DmTjM30f.mjs";
import { c as l } from "./tw-cn-mXgPecoF.mjs";
import { c as p } from "./index-BpNK5r1N.mjs";
const m = p(["flex flex-col gap-8 rounded-12 justify-center"], {
  variants: {
    theme: {
      warning: "bg-fill-warning-weak",
      info: "bg-fill-neutral-weak"
    },
    align: {
      left: "items-start",
      center: "items-center",
      right: "items-end"
    },
    type: {
      single: "px-16 py-4 min-h-40 pc:px-20 pc:min-h-48",
      multiple: "py-12 px-16 pc:py-16 pc:px-20 gap-12"
    }
  },
  defaultVariants: {
    theme: "warning",
    type: "single",
    align: "left"
  }
}), g = ({
  children: e,
  theme: t = "warning",
  type: s = "single",
  align: a = "left",
  className: n
}) => {
  const i = m({ theme: t, type: s, align: a });
  return /* @__PURE__ */ r.jsx("div", { className: l(i, n), children: e });
};
g.displayName = "NDS.MessageBox";
export {
  g as M
};
